export class User {
    id: number;
    username: string;
    password: string;
    firstName?: string;
    lastName?: string;
    token?: string;
    email: string;
}
export class User2 {
    id: number;
    kurumid:string;
    okul: string;
    okulilce:string;
    okulkodu:string;
    okulsehir:string;
    perid:string;
}